import secondaryComponents from "../../../../../components/secondaryComponents";
import globalStyles from "../../../../../assets/styles/base/globalPage.module.scss";
import { motion } from "framer-motion";
import { IntegratedTerminalForm } from "../../../../../components/secondaryComponents/IntegratedTerminals";
import { useAddIntegratedTerminals } from "./useAddIntegratedTerminals";

export const AddIntegratedTerminals = () => {
  const { isLoading, isFetchBusinessDetails, ...rest } =
    useAddIntegratedTerminals();

  return (
    <secondaryComponents.MetaSetter
      title="Lumi Merchant | Market - Connect Business"
      description="Manage business connections"
    >
      <secondaryComponents.RequestLoaderTrigger>
        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          className={`${globalStyles.pagePaddings} ${globalStyles.pageColumnGaps}`}
        >
          <secondaryComponents.LoaderHelper isLoading={isLoading}>
            <IntegratedTerminalForm {...rest} />
          </secondaryComponents.LoaderHelper>
        </motion.div>
      </secondaryComponents.RequestLoaderTrigger>
    </secondaryComponents.MetaSetter>
  );
};
